export const setUnitLabel = (unit: string, isMobile: boolean): string => {
  if (!unit) {
    return '';
  }

  if (unit.toLowerCase().includes('-pack')) {
    if (isMobile) {
      return `×${unit}`;
    }
    return `× ${unit}`;
  }
  return `${unit}`;
};
